import Track from 'core/logger/track';
import * as actions from '../models/actions/names';
import { Suggestion } from '../models/api';
import { UnderlinedClassnames } from '../utils';

class GrammarbotTrack {
  clickedCopyButton = (text: string, triggeredBy = 'copyAll') => {
    if (triggeredBy === 'insertButton') {
      Track.getInstance().ampEvent(actions.USER_CLICKED_INSERT_TO_DOC);
    }
    Track.getInstance().ampEvent(actions.USER_CLICKED_COPY_BUTTON, { triggeredBy });
    Track.getInstance().storeActionEvent(actions.USER_CLICKED_COPY_BUTTON, { text, triggeredBy });
  };

  clickedDeleteButton = () => {
    Track.getInstance().ampEvent(actions.USER_CLICKED_DELETE_TEXT);
    Track.getInstance().storeActionEvent(actions.USER_CLICKED_DELETE_TEXT);
  };

  clickedErrorNode = (errorTypes: string[]) => {
    Track.getInstance().ampEvent(actions.USER_OPENED_CORRECTION_CARD, { errorTypes });
    Track.getInstance().storeActionEvent(actions.USER_OPENED_CORRECTION_CARD, { errorTypes });
  };

  clickedCorrectAllGrammarErrorsButton = (numberOfGrammarErrors: number, triggeredBy: string) => {
    Track.getInstance().ampEvent(actions.USER_CLICKED_CORRECT_ALL_BUTTON, {
      numberOfGrammarErrors,
      triggeredBy,
    });
    Track.getInstance().storeActionEvent(actions.USER_CLICKED_CORRECT_ALL_BUTTON, {
      numberOfGrammarErrors,
      triggeredBy,
    });
  };

  clickedParaphraseButton = (
    text: string,
    numberOfGrammarErrors: number,
    numberOfWords: number
  ) => {
    Track.getInstance().ampEvent(actions.USER_CLICKED_PARAPHRASE_BUTTON, {
      numberOfGrammarErrors,
      numberOfWords,
    });
    Track.getInstance().storeActionEvent(actions.USER_CLICKED_PARAPHRASE_BUTTON, {
      text,
      numberOfGrammarErrors,
      numberOfWords,
    });
  };

  ignoredGrammarError = ({
    errorWord,
    correctedWordShown,
    sentence,
  }: {
    errorWord: string;
    correctedWordShown: string | Suggestion[];
    sentence: string;
  }) => {
    Track.getInstance().ampEvent(actions.USER_CLICKED_IGNORE_ERROR);
    Track.getInstance().storeActionEvent(actions.USER_CLICKED_IGNORE_ERROR, {
      errorWord,
      correctedWordShown,
      sentence,
    });
  };

  correctedGrammarError = ({
    errorWord,
    suggestionSelected,
    suggestionsShown,
    sentence,
  }: {
    errorWord: string;
    suggestionSelected: Suggestion;
    suggestionsShown: string | Suggestion[];
    sentence: string;
  }) => {
    const suggestionsShownType = (suggestionsShown as Suggestion[]).map(
      (suggestion) => suggestion.type
    );
    Track.getInstance().ampEvent(actions.USER_CLICKED_CORRECT_ERROR, {
      suggestionSelectedType: suggestionSelected.type,
      suggestionsShownType,
    });
    Track.getInstance().storeActionEvent(actions.USER_CLICKED_CORRECT_ERROR, {
      errorWord,
      suggestionSelected,
      suggestionsShown,
      sentence,
    });
  };

  userPastedText = (text: string, numberOfWords: number) => {
    Track.getInstance().ampEvent(actions.USER_PASTED_TEXT, {
      numberOfWords,
      numberOfCharacters: text?.trim()?.length,
    });
    Track.getInstance().storeActionEvent(actions.USER_PASTED_TEXT, {
      text,
      numberOfWords,
      numberOfCharacters: text?.trim()?.length,
    });
  };

  inputLimitExceeded = (limit: number, wordCount: number) => {
    Track.getInstance().storeActionEvent(actions.USER_EXCEEDED_INPUT_LIMIT, {
      limit,
      wordCount,
    });
    Track.getInstance().ampEvent(actions.USER_EXCEEDED_INPUT_LIMIT, {
      limit,
      wordCount,
    });
  };

  grammarCheckCompleted = () => {
    const totalSuggestions = document.querySelectorAll(
      `.${UnderlinedClassnames.ERROR_UNDERLINE_CLASS_NAME}, .${UnderlinedClassnames.PARAPHRASE_UNDERLINE_CLASS_NAME}`
    ).length;
    const errors = document.querySelectorAll(
      `.${UnderlinedClassnames.ERROR_UNDERLINE_CLASS_NAME}`
    ).length;
    const fluencySuggestions = document.querySelectorAll(
      `.${UnderlinedClassnames.PARAPHRASE_UNDERLINE_CLASS_NAME}`
    ).length;
    const simpleSuggestions = document.querySelectorAll(
      `.${UnderlinedClassnames.COMPLEX_UNDERLINE_CLASS_NAME}`
    ).length;
    Track.getInstance().storeActionEvent(actions.GRAMMAR_CHECK_COMPLETED, {
      totalSuggestions,
      errors,
      fluencySuggestions,
      simpleSuggestions,
    });
    Track.getInstance().ampEvent(actions.GRAMMAR_CHECK_COMPLETED, {
      totalSuggestions,
      errors,
      fluencySuggestions,
      simpleSuggestions,
    });
  };
}

const grammarbotTrack = new GrammarbotTrack();
export default grammarbotTrack;
